import React, { useContext, useEffect, useState } from 'react'
import LoginContext from "../../Context/Logincontext"
import Nav1 from '../../Component/Nav/Nav1'
import { NavLink } from 'react-router-dom'
// import "./../../styles/AddProduct.css"
import { urlApiServer } from '../../Config/Config'
import '../../styles/AddEmployee.css'
import Swal from 'sweetalert2'
import CloseButton from '../CloseButton'
import LogoComponent from '../LogoComponent'

const EditEmployee = (props) => {
    const urlPutEmployee = urlApiServer + "putemployee";
    const urlgetConfig = urlApiServer + "getConfig";

    const [name, setName] = useState(props.data?props.data.name:'')
    const [lastNameOne] = useState('')
    const [citizenshipCard, setCitizenshipCard] = useState(props.data?props.data.number_document:null)
    const [phone, setPhone] = useState(null)
    const [email, setEmail] = useState(null)
    const [position, setPosition] = useState(props.data?props.data.position:null)
    const [contact, setContact] = useState(null)
    const [typeDocument, setTypeDocument] = useState(props.data?props.data.type_document:null)

    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [oldConfig, setOldConfig] = useState("")
    const [logo, setLogo] = useState("")

    if (lastNameOne === undefined || lastNameOne === '') {
        var fullName = (name !== undefined ? name : '')
    } else {
        var fullName = (name !== undefined ? name : '') + ' ' + (lastNameOne !== undefined ? lastNameOne : '');
    }
    useEffect(() => {
        (async function () {

            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }
            await fetch(urlgetConfig, requesoption).then(response => response.json()).then(quotesResponse => {
                setOldConfig(quotesResponse)
            })
        }())
    }, [])

    useEffect(() => {
        if (oldConfig) {
            const foundConfig = oldConfig.find(obj => obj.empresa === infoUser.company);
            if (foundConfig) {
                const { logo } = foundConfig;
                setLogo(logo);
            }
        }
    }, [oldConfig, infoUser])

    async function handleName(e) {
        const name = e.target.value.replace(/[^A-Z a-z0-9.]/g, "");
        // if (/^[A-Za-z.\s]+$/.test(name) || name === '') {
        setName(name)
        // }
    }

    async function handleCitizenshipCard(e) {
        let value = e.target.value.replace(/[^\d-_]/g, '');
        e.target.value = value;
        setCitizenshipCard(value);
    }

    async function handleJob(e) {
        const direction = e.target.value
        setPosition(direction)
    }

    async function handleDocumentType(e) {
        let valueType = e.target.value
        console.log("valueType: ", valueType)
        if (/^[a-zA-Z ]+$/.test(valueType) || valueType === '') {
            setTypeDocument(valueType)
        }
    }

    async function handleBack() {
        props.edit()
    }

    async function uploadProduct() {

        if ((citizenshipCard === null) || (citizenshipCard === '')) {
            return Swal.fire({
                icon: 'warning',
                title: '¡Advertencia!',
                text: 'Recuerda llenar el campo de "Numero de documento"',
                allowOutsideClick: false,
            })
        }

        if ((typeDocument === null) || (typeDocument === '')) {
            return Swal.fire({
                icon: 'warning',
                title: '¡Advertencia!',
                text: 'Recuerda seleccionar un "Tipo de documento"',
                allowOutsideClick: false,
            })
        }

        if ((position === null) || (position === '')) {
            return Swal.fire({
                icon: 'warning',
                title: '¡Advertencia!',
                text: 'Recuerda llenar el campo de "Direccion"',
                allowOutsideClick: false,
            })
        }

        const data = JSON.stringify({
            empresa: infoUser.company,
            name: name,
            numberDocument: citizenshipCard,
            phone: phone,
            email: email,
            position: position,
            contact: contact,
            id: props.data.Id,
            typeDocument: typeDocument,
        })
        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json")

        const requesoption = {
            method: 'PUT',
            headers: registerHeaders,
            body: data,
            redirect: 'follow'
        }

        await fetch(urlPutEmployee, requesoption).then(response => response.json())
            .then(dataResponse => {
                if (200 === dataResponse.status) {
                    return Swal.fire({
                        icon: 'success',
                        title: '¡Hecho!',
                        text: dataResponse.msj,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = './Empleados';
                        }
                    })
                }
                if (101 === dataResponse.status) {
                    return Swal.fire({
                        icon: 'error',
                        title: '¡Error!',
                        text: dataResponse.msj,
                        confirmButtonText: 'Aceptar',
                    })
                }
            })
    }

    return (
        <>
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    <>
                        <div className="containerHeardANDTable">
                            <div className="HeardANDFilter">
                                <LogoComponent />
                                <div className='containerButtonAdd'>
                                    <div className="navigationContainer">
                                        <div className="pageTitle">CREAR EMPLEADO</div>
                                    </div>
                                </div>
                                <div className='closeIntContainer'>
                                    <CloseButton />
                                </div>
                            </div>
                        </div>
                        <div id='overallContainer' className='overallContainer'>
                            <Nav1 />
                            <div className='drawerFormAddCuotes'>
                                <form className='ContainerClient'>
                                    <div className='containerInfoEdit'>
                                        <div className='infoOneEdit'>
                                            <p className='personalInformationEdit'>INFORMACIÓN DEL EMPLEADO</p>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        value={name}
                                                        name="Name"
                                                        id="Name"
                                                        onChange={handleName}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Nombre del empleado <em className='Obligatory'>*</em> </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        name="nitSelect"
                                                        id="nitSelect"
                                                        className="inputCLient"
                                                        placeholder=""
                                                        list="drawfemails2"
                                                        onChange={handleDocumentType}
                                                        value={(typeDocument === '') ? ('') : (typeDocument)}
                                                    />
                                                    <label htmlFor="name">Tipo de documento: <em className='Obligatory'>*</em>  </label>
                                                    <datalist id="drawfemails2" value="nitSelect">
                                                        <option value="NIT">NIT</option>
                                                        <option value="Cedula de ciudadania">Cedula de ciudadania</option>
                                                        <option value="Cedula de extranjeria">Cedula de extranjeria</option>
                                                        <option value="Tarjeta de identidad">Tarjeta de identidad</option>
                                                    </datalist>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="citizenshipCard"
                                                        id="citizenshipCard"
                                                        onChange={handleCitizenshipCard}
                                                        className="inputCLient"
                                                        value={citizenshipCard}
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Numero de documento <em className='Obligatory'>*</em> </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        name="direction"
                                                        id="direction"
                                                        onChange={handleJob}
                                                        className="inputCLient"
                                                        value={position}
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Cargo <em className='Obligatory'>*</em> </label>
                                                </div>
                                            </div>
                                            <div className="buttonContainerAddClient">
                                                <NavLink className='Textregister' to="/Empleados" onClick={handleBack}><button className="button neon_Effect"><p>Atras</p></button></NavLink>
                                                <NavLink onClick={uploadProduct} className='Textregister'><button className="button neon_Effect"><p>Actualizar</p></button></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                )
            ) : (window.location.href = './Iniciar_Sesión')}
        </>
    )

}

export default EditEmployee